import { animate, inView } from 'motion'

export default () => ({
  checkPrefersReducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  },

  init() {
    if (this.checkPrefersReducedMotion()) {
      return
    }

    animate(this.$el, { opacity: 0 }, { duration: 0 })

    inView(
      this.$el,
      (element) => {
        animate(
          element,
          { opacity: [0, 1] },
          {
            duration: 0.6,
          },
        )
      },
      { amount: 0.7 },
    )
  },
})
